import {
  Action,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import { BookingType } from '@/types/Booking';

@Module({
  namespaced: true
})
class BookingModule extends VuexModule {
  private booking: BookingType = {} as BookingType ;

  get getBooking() {
    return this.booking;
  }

  @Mutation
  setBooking(value: BookingType) {
    this.booking = value;
  }

  @Action({ commit: 'setBooking', rawError: true })
  async addBooking(payload:  BookingType): Promise<BookingType> {
    return payload;
  }
}

export default BookingModule;
